import React, { useEffect } from "react";
import { Col, Image, Row } from "react-bootstrap";
import VouchurePic from "../../assets/vouchure.svg";
import CouponPic from "../../assets/coupens.svg";
import ShopPic from "../../assets/Shop.svg";
import Checked from "../../assets/checked.svg";
import GreenChecked from "../../assets/Greenchecked.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CompareModal from "../../Components/CompareModal/CompareModal";
import { GetSubscriptiondetailsApi } from "../../Utils/Api/GetSubscriptiondetailsApi";
import { userId } from "../../Utils/LocalStorage";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import Loader from "../../Components/Loader/Loader";
import { CompareSubscriptionApi } from "../../Utils/Api/CompareSubscriptionApi";
import { useDispatch } from "react-redux";
import { getMySubscriptionPlanId } from "../../redux/MyProfileSubscriptionSlice";
import { RotatingLines } from "react-loader-spinner";

const MyProfileSubscriptionLock = () => {
  const [modalShow, setModalShow] = useState(false);
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [CompareSubscriptionData, setCompareSubscriptionData] = useState({});
  const [activeNumberOfVouchers, setActiveNumberOfVouchers] = useState(0);
  const [activeNoOfCoupons, setActiveNoOfCoupons] = useState(0);
  const [currentPlan, setCurrentPlan] = useState(0);
  const [btnloading, setBtnloading] = useState(false);
  const [planIdFlag, setPlanIdFlag] = useState("");
  const [totalSubscribedMarketplaces, setTotalSubscribedMarketplaces] =
    useState(0);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const Uid = userId();
  const dispatch = useDispatch();

  const GetSubscriptiondetails = async () => {
    const data = {
      user_id: Uid,
    };
    setLoading(true);
    const GetSubscriptiondetailsRes = await GetSubscriptiondetailsApi(
      data,
      () => {
        navigate("/");
      }
    );
    if (GetSubscriptiondetailsRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (GetSubscriptiondetailsRes.success === true) {
        setSubscriptionDetails(
          GetSubscriptiondetailsRes.data.subscription_data
        );
        setActiveNumberOfVouchers(GetSubscriptiondetailsRes.data.voucher_count);
        setActiveNoOfCoupons(GetSubscriptiondetailsRes.data.coupon_count);
        setTotalSubscribedMarketplaces(
          GetSubscriptiondetailsRes.data.marketplace_count
        );
        setCurrentPlan(GetSubscriptiondetailsRes.data.current_plan);
        setLoading(false);
      }else if (GetSubscriptiondetailsRes.status === 429) {
        setLoading(true);
        toast.error(GetSubscriptiondetailsRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        setSubscriptionDetails([]);
        setActiveNumberOfVouchers(0);
        setActiveNoOfCoupons(0);
        setTotalSubscribedMarketplaces(0);
        setLoading(false);
      }
    }
  };

  const dummydata = [
    {
      currentplanflag: 0,
      Title: subscriptionDetails[0]?.subscription_name,
      Heading: subscriptionDetails[0]?.subscription_price,
      BulletPoints: [
        subscriptionDetails[0]?.subscription_marketplace_count +
          " " +
          "Marketplace",
        subscriptionDetails[0]?.subscription_voucher_count + " " + "Voucher",
        subscriptionDetails[0]?.subscription_coupon_count + " " + "Coupon",
      ],
      status: subscriptionDetails[0]?.subscription_id,
      recomended: subscriptionDetails[0]?.subscription_is_recommended,
    },
    {
      currentplanflag: 1,
      Title: subscriptionDetails[1]?.subscription_name,
      Heading: subscriptionDetails[1]?.subscription_price,
      BulletPoints: [
        subscriptionDetails[1]?.subscription_marketplace_count +
          " " +
          "Marketplace",
        subscriptionDetails[1]?.subscription_voucher_count + " " + "Voucher",
        subscriptionDetails[1]?.subscription_coupon_count + " " + "Coupon",
      ],
      status: subscriptionDetails[1]?.subscription_id,
      recomended: subscriptionDetails[1]?.subscription_is_recommended,
    },
    {
      currentplanflag: 2,
      Title: subscriptionDetails[2]?.subscription_name,
      Heading: subscriptionDetails[2]?.subscription_price,
      BulletPoints: [
        subscriptionDetails[2]?.subscription_marketplace_count +
          " " +
          "Marketplace",
        subscriptionDetails[2]?.subscription_voucher_count + " " + "Voucher",
        subscriptionDetails[2]?.subscription_coupon_count + " " + "Coupon",
      ],
      status: subscriptionDetails[2]?.subscription_id,
      recomended: subscriptionDetails[2]?.subscription_is_recommended,
    },
  ];
  // const titles = dummydata.map((item) => item.Title);

  // const ChangePlan = (status, flag) => {
  //   if (status === 0) {
  //     if (flag === 0) {
  //       navigate("/my-profile/subscription/free-plan-details");
  //     } else if (flag === 1) {
  //       navigate("/my-profile/subscription/tier-II-details");
  //     } else {
  //       navigate("/my-profile/subscription/tier-III-details");
  //     }
  //   }
  // };

  const CompareModalApiHandler = async (planId) => {
    setPlanIdFlag(planId);

    const data = {
      user_id: Uid,
      plan_id: planId,
      current_plan_id: currentPlan,
    };

    setBtnloading(true);
    const CompareModalApiRes = await CompareSubscriptionApi(data, () => {
      navigate("/");
    });
    if (CompareModalApiRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setBtnloading(false);
    } else {
      if (CompareModalApiRes.success === true) {
        if (planId === 1) {
          dispatch(getMySubscriptionPlanId(planId));
          navigate("/my-profile/subscription/tier-details");
        } else if (planId === 2) {
          dispatch(getMySubscriptionPlanId(planId));
          navigate("/my-profile/subscription/tier-details");
        } else {
          dispatch(getMySubscriptionPlanId(planId));
          navigate("/my-profile/subscription/tier-details");
        }
        setBtnloading(false);
      }else if (CompareModalApiRes.status === 429) {
        setLoading(true);
        toast.error(CompareModalApiRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        if (CompareModalApiRes.is_eligible === false) {
          setCompareSubscriptionData(CompareModalApiRes.data);
          setBtnloading(false);
          setModalShow(true);
        }
      }
    }
  };

  useEffect(() => {
    GetSubscriptiondetails();
  }, []);

  return (
    <div className="MyProfileSubscription">
      {loading === true ? <Loader /> : ""}
      <Row className="dashboard-card mt-4 ">
        <Col md="4">
          <div className="card">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image loading="lazy" src={VouchurePic} height="15px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Active No of vouchers</p>
              <p className="dash-text2">
                {activeNumberOfVouchers ? activeNumberOfVouchers : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="4">
          <div className="card">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image loading="lazy" src={CouponPic} height="25px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Active No of Coupons</p>
              <p className="dash-text2">
                {activeNoOfCoupons ? activeNoOfCoupons : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="4">
          <div className="card">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image loading="lazy" src={ShopPic} height="20px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">total subscribed marketplaces</p>
              <p className="dash-text2">
                {totalSubscribedMarketplaces ? totalSubscribedMarketplaces : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          subscriptionDetails?.length > 0
            ? "mt-4 TierCardRow TierCard_padding"
            : "mt-4 TierCardRow"
        }
      >
        {subscriptionDetails?.length > 0 ? (
          dummydata?.map((data, i) => {
            return (
              <Col
                key={i}
                className={
                  data.status === currentPlan
                    ? "TierCard renewCard"
                    : data.recomended === 1
                    ? "TierCard recommended"
                    : "TierCard"
                }
                md="4"
              >
                <p className="planP">{data.Title}</p>
                <h1>
                  ${data.Heading}
                  <span>{data.status === 0 ? "/month" : ""}</span>
                </h1>
                <div className="TierList">
                  {data.BulletPoints.map((b, i) => {
                    return (
                      <li key={i}>
                        <img
                          loading="lazy"
                          src={
                            data.status === currentPlan ? GreenChecked : Checked
                          }
                        />
                        {b}
                      </li>
                    );
                  })}
                </div>
                <p
                  className="ChangeTag"
                  onClick={() => {
                    data.status === currentPlan
                      ? setModalShow(false)
                      : CompareModalApiHandler(data.status);
                  }}
                >
                  <b>
                    {data.status === currentPlan ? (
                      "Renew Plan"
                    ) : planIdFlag === data.status && btnloading === true ? (
                      <RotatingLines
                        strokeColor="white"
                        width={20}
                        visible={true}
                      />
                    ) : (
                      "Change Plan"
                    )}
                  </b>
                </p>
                {data.recomended === 1 ? (
                  <p className="RecommendedTag">Recommended</p>
                ) : (
                  <></>
                )}
              </Col>
            );
          })
        ) : (
          <></>
        )}
      </Row>
      <CompareModal
        show={modalShow}
        CompareData={CompareSubscriptionData}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
};

export default MyProfileSubscriptionLock;
